<div class="row">
  <div class="aa-parent">
    <div></div>
    <div class="col-sm-12" style="max-width: 1020px">
      <customer-feedback-form *ngIf="eventForm && eventFeedbackCustomerForm" [editMode]="editMode" [eventFeedbackCustomerForm]="eventFeedbackCustomerForm" [eventForm]="eventForm" [buid]="buid"></customer-feedback-form>
    </div>
    <div></div>
  </div>
</div>
